import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { catchError, Observable, of } from "rxjs";
import { Page } from "../models/page.model";
import { Agency } from "../models/agency.model";

/**
 * PURPOSE: responsible for making all Agency related HTTP API calls
 */
@Injectable({
  providedIn: "root"
})
export class AgencyService {
  constructor(private http: HttpClient) {}

  /**
   * Retrieves an agency by agency ID
   */
  public getAgency(agencyId: number): Observable<Page<Agency>> {
    return this.http
      .get<
        Page<Agency>
      >(`${environment.fulcrumUrl}/api/v3/agencies`, this.buildHttpOptions(agencyId))
      .pipe(
        catchError((error: HttpErrorResponse): Observable<Page<Agency>> => {
          if (error.status === 404) {
            console.log("Not Found");
            return of();
          }
          console.log(error);
          throw error;
        })
      );
  }

  /**
   * Retrieves the prepaid balance of an agency by agency ID
   */
  public getAgencyPrepaidBalance(agencyId: number): Observable<number> {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      }),
      params: {}
    };

    return this.http
      .get<number>(
        `${environment.fulcrumUrl}/iw/api/v1/agency/${agencyId}/settings/claim-it/prepaid/balance`,
        httpOptions
      )
      .pipe(
        catchError((error: HttpErrorResponse): Observable<number> => {
          if (error.status === 404) {
            console.log("Not Found");
            return of();
          }
          console.log(error);
          throw error;
        })
      );
  }

  private buildHttpOptions(agencyId: number) {
    return {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization:
          "Basic " + btoa(`${environment.claimItApiUsername}:${environment.claimItApiPassword}`)
      }),
      params: new HttpParams().set("fulcrumId", agencyId)
    };
  }
}
